(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('TrainingRequirementsController', TrainingRequirementsController);

    TrainingRequirementsController.$inject = ['$scope', '$state', '$stateParams', 'TrainingRequirements', 'paginationConstants', 'pagingParams', 'ParseLinks'];

    function TrainingRequirementsController ($scope, $state, $stateParams, TrainingRequirements, paginationConstants, pagingParams, ParseLinks) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            TrainingRequirements.get({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== '(u.last_name)') {
                    result.push('(u.last_name)');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.trainingRequirements = data;
                vm.page = pagingParams.page;

                console.log('onSuccess -> data');
                console.log(data);
            }
            function onError(error) {}
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();
